import { forwardRef, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import InputDatePicker from "./InputDatePicker";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

type Props = {
  value: Date;
  onChange: (value: Date) => void;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  outlined?: boolean;
  width?: string;
  format?: string;
  ghostText?: string;
  filterDate?: any;
  label?: string;
  required?: boolean;
  error?: string;
};

const DatePickerInput = ({
  value,
  onChange,
  disabled,
  maxDate,
  minDate,
  width,
  outlined = true,
  format,
  ghostText,
  filterDate,
  label,
  required,
  error,
}: Props) => {
  const inputRef = useRef(null);
  const CustomInput = forwardRef((props: any, ref) => {
    return <InputDatePicker {...props} ref={ref} />;
  });

  return (
    <TextAreaWrapper>
      <Label>
        {label}
        {required && <Required>*</Required>}
      </Label>
      <DatePicker
        selected={value}
        onChange={(date: Date) => {
          onChange(date);
        }}
        customInput={
          <CustomInput
            ghostText={ghostText}
            outlined={outlined}
            width={width}
            inputRef={inputRef}
            error={error}
          />
        }
        dateFormat={format || "dd MMM yyyy"}
        maxDate={maxDate}
        minDate={minDate}
        disabled={disabled}
        filterDate={filterDate || false}
      />
      <ErrorRequired>{error}</ErrorRequired>
    </TextAreaWrapper>
  );
};

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const Label = styled.label`
  color: ${Colors.purplishGrey};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  line-height: 0.75rem;
`;

const Required = styled.span`
  color: ${Colors.red};
`;

const ErrorRequired = styled.span`
  color: ${Colors.red};
  font-size: 12px;
`;

export default DatePickerInput;
